module.exports = ":host {\n    display: block;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main